import * as React from 'react';
import { Either } from '@/utils/typescript';

export type ImageInputProps = Omit<React.HTMLAttributes<HTMLImageElement>, 'src' | 'onChange' | 'onClick'> & {
    value?: number;
    defaultImage?: { fullUrl: string; imageId: number };
    onChange?: (value: number | null) => void;
    isDisabled?: boolean;
    maxFileSize?: number;
    validateFile?: (file: File) => Promise<string | null>;
    disableResize?: boolean;
} & Either<{ brandId: number }, { restaurantId: number }>;

export enum Sections {
    Library = 'library',
    Upload = 'upload',
}

export type ImageInputState = {
    isModalOpen: boolean;
    currentSection: Sections;
    isUploadLoading: boolean;
    page: number;
    search: string;
    resize: boolean;
};

export enum ImageInputActionType {
    TOGGLE_MODAL = 'TOGGLE_MODAL',
    SET_SECTION = 'SET_SECTION',
    SET_UPLOAD_LOADING = 'SET_UPLOAD_LOADING',
    NEXT_PAGE = 'NEXT_PAGE',
    SET_SEARCH = 'SET_SEARCH',
    SWITCH_RESIZE = 'SWITCH_RESIZE',
}

export type ImageInputAction =
    | {
          type: ImageInputActionType.TOGGLE_MODAL;
          payload: boolean;
      }
    | { type: ImageInputActionType.SET_SECTION; payload: Sections }
    | {
          type: ImageInputActionType.SET_UPLOAD_LOADING;
          payload: boolean;
      }
    | { type: ImageInputActionType.NEXT_PAGE }
    | { type: ImageInputActionType.SET_SEARCH; payload: string }
    | { type: ImageInputActionType.SWITCH_RESIZE };
